// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate:marketing` to regenerate.

/** schema.org JSON-LD graphs injected by the <StructuredData> head component. */
export const ORGANISATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Inferrex",
  "legalName": "Inferrex Ltd",
  "url": "https://inferrex.com",
  "logo": "https://inferrex.com/logos/inferrex-icon-512.png",
  "description": "Self-healing integration infrastructure. Connect any API, map any data, heal any breakage — automatically.",
  "sameAs": [
    "https://www.linkedin.com/company/inferrex"
  ]
} as const;

export const SOFTWARE_APPLICATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Inferrex",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Cloud, Self-hosted, Air-gapped",
  "url": "https://inferrex.com",
  "description": "Self-healing integration infrastructure that runs entirely inside your own environment — including air-gapped and regulated deployments.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "GBP",
    "lowPrice": "149.00",
    "offerCount": 4,
    "offers": [
      {
        "@type": "Offer",
        "name": "Pilot",
        "price": "149.00",
        "priceCurrency": "GBP"
      },
      {
        "@type": "Offer",
        "name": "Starter",
        "price": "499.00",
        "priceCurrency": "GBP"
      },
      {
        "@type": "Offer",
        "name": "Growth",
        "price": "1999.00",
        "priceCurrency": "GBP"
      },
      {
        "@type": "Offer",
        "name": "Scale",
        "price": "4999.00",
        "priceCurrency": "GBP"
      }
    ]
  }
} as const;

/** Combined site-wide graph rendered on every page. */
export const SITE_JSONLD: readonly object[] = [ORGANISATION_JSONLD, SOFTWARE_APPLICATION_JSONLD];
